import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { injectContext } from '@taiga-ui/polymorpheus';
import { TuiDialogContext } from '@taiga-ui/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { StepType } from './types';
import { PermissionsService, StorageService, WelcomeDialogsService } from './services';
import { BASE_PATH_API } from './constants';

@Component({
  selector: 'app-welcome-dialogs',
  templateUrl: './welcome-dialogs.component.html',
  styleUrls: ['./welcome-dialogs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeDialogsComponent extends BaseResizableComponent {
  private readonly context = injectContext<TuiDialogContext<boolean>>();
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);
  private readonly permissions = inject(PermissionsService);
  private readonly storage = inject(StorageService);
  private readonly welcomeDialogsService = inject(WelcomeDialogsService);

  stepIndex = 0;
  visibleSteps: StepType[] = [];

  steps: StepType[] = [
    {
      visible: this.permissions.allowViewingNotificationDialog(),
      visibleIndex: 1,
      imageSrc: this.welcomeDialogsService.appConfig?.notificationsInfoImage
        ? BASE_PATH_API + this.welcomeDialogsService.appConfig.notificationsInfoImage
        : undefined,
      description: this.welcomeDialogsService.appConfig?.notificationsInfoText ?? 'Текст не указан',
      buttons: {
        left: {
          text: this.translateService.instant('components.welcomeDialogs.buttons.allowNotifications'),
          action: () => this.displayRequestForNotification(),
        },
        right: {
          text: this.translateService.instant('components.welcomeDialogs.buttons.later'),
          action: () => this.setFirstDeviceLogin(),
        },
      },
    },
    {
      visible: this.permissions.allowViewingProfileDialog(),
      visibleIndex: 2,
      iconSrc: '@tui.user',
      title: this.translateService.instant('components.welcomeDialogs.labels.checkProfileTitle'),
      description: this.translateService.instant('components.welcomeDialogs.labels.checkProfileDescription'),
      buttons: {
        left: {
          text: this.translateService.instant('components.welcomeDialogs.buttons.toProfile'),
          action: () => this.goToProfile(),
        },
        right: {
          text: this.translateService.instant('components.welcomeDialogs.buttons.later'),
          action: () => this.goToNextStep(true),
        },
      },
    },
  ];

  ngOnInit(): void {
    super.ngOnInit();

    this.visibleSteps = this.steps.sort((a, b) => a.visibleIndex - b.visibleIndex).filter(step => !!step.visible);
  }

  private setFirstDeviceLogin() {
    this.storage.setFirstDeviceLogin();
    this.goToNextStep();
  }

  private displayRequestForNotification() {
    this.welcomeDialogsService.isAccessToNotifications().then(() => {
      this.setFirstDeviceLogin();
    });
  }

  private goToProfile() {
    this.router.navigate(['settings', 'profile']);
    this.close(true);
  }

  close(callChangeToken = false) {
    this.context.completeWith(callChangeToken);
  }

  goToNextStep(callChangeToken = false) {
    this.stepIndex++;

    if (this.stepIndex >= this.visibleSteps.length) {
      this.close(callChangeToken);
    }

    this.cdr.markForCheck();
  }
}
